const getScrollInfo = (element) => {
  const { overflow } = window.getComputedStyle(element);
  const { scrollHeight, clientHeight, scrollTop } = element;
  const isVisible = overflow !== 'hidden' && scrollHeight > clientHeight;

  return {
    isVisible,
    position: {
      bottom: scrollHeight - scrollTop === clientHeight,
      top: !scrollTop,
    },
  };
};

export default getScrollInfo;
